import {
    Component,
    ElementRef,
    Input,
    ViewChild,
    EventEmitter,
    Output,
    CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';

import 'media-chrome';
import 'youtube-video-element';

@Component({
    selector: 'app-media-chrome-player',
    templateUrl: './media-chrome-player.component.html',
    styleUrls: ['./media-chrome-player.component.scss'],
    imports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MediaChromePlayerComponent {
    @ViewChild('mediaEl', { static: false }) mediaElRef!: ElementRef<any>;

    @Input() loop: boolean = true;
    @Input() controls: boolean = false;
    @Input() muted: boolean = true;
    @Input() autoplay: boolean = true;
    @Input() src: string = '';
    @Input() title: string = '';
    @Input() type: 'youtube' | 'video' = 'video';

    @Output() ended_event = new EventEmitter<void>();

    public state: 'play' | 'paused' = 'paused';

    constructor() { }

    playState(event: 'play' | 'paused') {
        this.state = event;
    }

    onEnded(): void {
        this.ended_event.emit();
    }
}
